import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./noRights.scss";
import { Button } from "react-bootstrap";

const NoRights = (props) => {
  const navigate = useNavigate();


  const LearnMore = () => {
    window.open("https://support.vagaro.com/hc/en-us/articles/204974584-Employee-Access-Levels-What-They-All-Mean", "_blank");
  }

  return (

    <div className="noRight static">
      <div className="text-center noRightContent">
        <div className="icon">
          <i className="far fa-lock-alt"></i>
        </div>
        <h2>Access Denied</h2>
        <div className="noRightText">
          Admin have not been given access to this page. 
          <br></br>Please select any business.
        </div>
      </div>
      <div className="justify-content-center noRightfooter">
        <button className="w-button w-button-secondary" onClick={LearnMore}>Learn More</button>
        <button className="w-button w-button-primary" onClick={
            props.onCancel ?()=> props.onCancel() :
          
          () => navigate(-1)
        
        }>Go Back</button>
      </div>
    </div>

  );
};
export default NoRights;
